var _desc, _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "fc9a9255-e89b-4dc0-8903-d91c3453a9eb"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "d3cf8a2e-a9fb-4640-acc4-d9c2b9ef623c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.1 0 0 2.1 582.94 508.8)",
    id: "2f3d9430-a737-4135-93f8-8dfc93b9982b"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(238,243,246)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-145.66, -145.66)",
    d: "M 145.66 0 C 65.219 0 0 65.219 0 145.66 C 0 226.11 65.219 291.32 145.66 291.32 C 226.101 291.32 291.32 226.11 291.32 145.66 C 291.319 65.219 226.1 0 145.66 0 z M 186.462 256.625 C 185.624 245.227 184.68699999999998 231.107 184.63199999999998 225.39 C 184.26799999999997 221.00199999999998 183.79399999999998 209.84099999999998 173.19799999999998 202.713 C 215.26599999999996 199.19 235.28499999999997 175.939 236.724 145.214 C 237.926 127.717 230.97 112.33099999999999 218.617 99.914 C 219.24499999999998 86.632 218.21599999999998 70.891 217.361 63.973 C 207.875 61.242 185.753 72.922 179.571 77.92 C 166.534 72.858 134.626 71.083 115.235 77.92 C 101.488 68.25200000000001 85.839 62.28 77.309 63.946 C 69.434 81.398 74.496 97.894 76.03399999999999 99.86 C 65.892 109.128 51.74499999999999 120.535 55.58699999999999 144.43200000000002 C 61.749999999999986 179.472 86.40299999999999 198.372 126.09499999999998 202.996 C 117.62899999999999 204.726 116.19899999999998 211.044 115.48899999999999 213.78400000000002 C 88.833 224.781 81.214 206.99300000000002 77.845 202.359 C 66.657 188.512 56.614999999999995 192.52700000000002 55.995999999999995 192.745 C 55.394999999999996 192.963 54.94 193.83700000000002 55.004 194.256 C 55.568 197.242 61.659 200.274 61.958999999999996 200.519 C 70.216 206.673 73.27499999999999 217.78900000000002 75.15899999999999 220.957 C 87.00299999999999 240.43 114.53299999999999 232.355 114.797 232.519 C 114.815 234.221 114.606 248.55100000000002 114.442 259.70300000000003 C 64.245 245.992 27.311 200.2 27.311 145.66 C 27.311 80.295 80.295 27.311999999999998 145.659 27.311999999999998 C 211.02299999999997 27.311999999999998 264.008 80.295 264.008 145.66 C 264.008 196.668 231.69 239.992 186.462 256.625 z",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.3195c74c6208b3642bb22521e62ff8e3.svg";
export { ForwardRef as ReactComponent };